module.exports = __webpack_public_path__ + "static/media/unibestWeb2.02a8c5b0.png";